import React from 'react';
import EndoSetupSopesTable from '../../AppGrid/EndoSetupSopes';

const EndoSetupScopeList = () => {
	return (
		<EndoSetupSopesTable/>
	);
};
export default EndoSetupScopeList;
